import { GoogleMapComponent } from './../common-theme/gmaps/google-map/google-map.component';
import { Component, ViewChild } from '@angular/core';
import { InterfaceComponent } from './interface.component';

@Component({
  selector: 'app-gmap',
  templateUrl: './gmap.component.html',
  styleUrls: [
    './../common-theme/gmaps/google-map/google-map.component.scss',
    './gmap.component.scss'
  ]
})

export class GmapComponent extends GoogleMapComponent {
  @ViewChild(InterfaceComponent) interface: InterfaceComponent;
}



// WEBPACK FOOTER //
// ./src/app/localisation/gmap.component.ts